import React, { useState } from "react";
import AdminAPI from "../utils/adminApi"; // 👈 Axios instance with /admin base + token

const AdminCredit = () => {
  const [email, setEmail] = useState("");
  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCredit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await AdminAPI.post("/credit", { email, amount });
      setMessage(res.data?.message || `✅ Credited ₦${amount} to ${email}`);
      setEmail("");
      setAmount("");

      setTimeout(() => setMessage(""), 4000);
    } catch (err) {
      console.error("❌ Credit vendor failed:", err.response?.data || err.message);
      setMessage(err.response?.data?.message || "❌ Failed to credit user");
      setTimeout(() => setMessage(""), 4000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow max-w-md mx-auto mt-8">
      <h2 className="text-xl font-bold mb-4">💳 Credit User</h2>

      {message && (
        <p
          className={`mb-4 text-sm ${
            message.startsWith("✅") ? "text-green-600" : "text-red-600"
          }`}
        >
          {message}
        </p>
      )}

      <form onSubmit={handleCredit} className="space-y-4">
        <input
          type="email"
          placeholder="User Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
          required
        />
        <input
          type="number"
          placeholder="Amount (₦)"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
          required
          min="1"
        />
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
        >
          {loading ? "Processing..." : "Credit User"}
        </button>
      </form>
    </div>
  );
};

export default AdminCredit;
